import './assets/main.css'
import './assets/animations.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { useAuthStore } from '@/stores/auth'
import { initSentry } from './sentry'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)

if (import.meta.env.VITE_SENTRY_DSN) {
  initSentry(app, router)
}

app.config.errorHandler = (err, instance, info) => {
  console.error('Vue component error:', err, info)
}

app.use(router)

const authStore = useAuthStore()
authStore.initialize()

app.mount('#app')
